'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
var fieldset$1 = require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
var fieldset = require('../../../../styles/styled-components/fieldset.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
var fonts = require('../../../../themes/fonts.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
var screenReader = require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
var baseFieldset = require('../base-fieldset/base-fieldset.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseStandardFieldset = (props)=>{
    const { children , className , disabled , legend , legendProps , showLegend =true , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(baseFieldset.BaseFieldset, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-fieldset__standard': true,
            [`bf-fieldset__standard--${disabled}`]: disabled,
            [`${className}`]: className
        }),
        disabled: disabled
    }), /*#__PURE__*/ React__default.default.createElement("legend", _extends({}, legendProps, {
        className: classnames__default.default({
            'bf-fieldset__standard-legend': true,
            'bf-fieldset__standard-legend--hidden': !showLegend,
            [`${legendProps?.className}`]: !!legendProps?.className
        })
    }), legend), children);
};
const Fieldset = styled__default.default(BaseStandardFieldset)`
  border-style: solid;
  border-width: 1px;
  display: block;
  font-family: ${fonts.fontFamilyBook};
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  padding: 30px;
  ${({ look  })=>fieldset.getFieldsetTheme({
        look
    })}

  .bf-fieldset__standard-legend {
    display: block;
    font-family: ${fonts.fontFamilyBook};
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    margin-bottom: 20px;
    padding: 0;
    position: relative;
    top: 35px;
    ${({ showLegend  })=>showLegend ? '' : screenReader.screenReaderOnly}
  }
`;
/**
 * A fieldset is used to group several controls and labels within a form.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/fieldset
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/legend
 *
 * @param props StandardFieldsetProps
 * @returns FunctionComponent<StandardFieldsetProps>
 */ const StandardFieldset = (props)=>{
    const { look =fieldset$1.FieldsetLooks.Default  } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Fieldset, _extends({}, props, {
        look: look
    })));
};

exports.BaseStandardFieldset = BaseStandardFieldset;
exports.StandardFieldset = StandardFieldset;
//# sourceMappingURL=standard-fieldset.js.map
